import { useLocation } from 'react-router-dom';

// see https://reactrouter.com/web/example/query-parameters
export function useQuery() {
  const location = useLocation();
  return new URLSearchParams(location.search);
}
